import { render } from "./KennissLogo.vue?vue&type=template&id=68b2769c&ts=true"
import script from "./KennissLogo.vue?vue&type=script&lang=ts"
export * from "./KennissLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__